(() => {
  if (window.ciCollectionOrderInstalled) return;
  window.ciCollectionOrderInstalled = true;
  async function initialize(grid) {
    if (grid.dataset.ciOrdering) return;
    grid.dataset.ciOrdering = 'true';
    const host = grid.closest('.collection');
    const originalPagination = host.querySelector('.pagination-wrapper');
    const pageSize = Number(grid.dataset.ciPageSize) || 36;
    const total = Number(grid.dataset.ciTotal);
    let cards = [...grid.children];
    try {
      let next = grid.dataset.ciNext;
      // An old ad/bookmark can open page 2: rebuild from page 1 without changing its URL.
      if (Number(grid.dataset.ciCurrent) > 1) {
        const first = new URL(location.href); first.searchParams.set('page', '1');
        next = first.href; cards = [];
      }
      const seen = new Set();
      while (next) {
        if (!grid.isConnected) return;
        const url = new URL(next, location.origin);
        if (url.origin !== location.origin) throw Error('Unexpected origin');
        url.searchParams.set('section_id', grid.dataset.id);
        if (seen.has(url.href)) throw Error('Pagination loop');
        seen.add(url.href);
        const response = await fetch(url);
        if (!response.ok) throw Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-ci-collection-grid]');
        if (!source) throw Error('Missing collection grid');
        cards.push(...source.children);
        next = source.dataset.ciNext;
      }
      if (!grid.isConnected) return;
      cards = [...new Map(cards.map(card => [card.dataset.ciProduct, card])).values()];
      if (cards.length !== total) throw Error('Incomplete collection');
      cards.sort((a, b) => Number(b.dataset.ciAvailable === 'true') - Number(a.dataset.ciAvailable === 'true'));
      // Fetched cards do not pass through Dawn's original intersection observer.
      cards.forEach(card => card.classList.remove('scroll-trigger', 'animate--slide-in'));
      let visible = pageSize, shown = 0;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'ca-button ca-more ci-collection-more';
      button.textContent = 'Mostra altre creazioni →'; button.setAttribute('aria-controls', grid.id);
      const status = document.createElement('p'); status.setAttribute('role', 'status'); status.className = 'visually-hidden';
      function render() {
        if(shown===0)grid.replaceChildren(...cards.slice(0,visible));else grid.append(...cards.slice(shown,visible));
        shown=Math.min(visible,cards.length);
        button.hidden = visible >= cards.length;
        status.textContent = Math.min(visible, cards.length) + ' di ' + cards.length + ' creazioni';
      }
      button.addEventListener('click', () => {
        const previous = visible; visible += pageSize;
        setTimeout(()=>{render();grid.children[previous]?.querySelector('a')?.focus({preventScroll:true});},0);
      });
      originalPagination?.remove();
      grid.after(status, button); render();
    } catch (error) {
      // Native Liquid cards and native pagination remain available on request failures.
      if (grid.isConnected) {
        const status = document.createElement('p'); status.setAttribute('role', 'status');
        status.textContent = 'Ordinamento completo non disponibile. Ricarica la pagina; puoi continuare con la paginazione.';
        grid.after(status);
      }
    }
  }
  const scan = () => document.querySelectorAll('[data-ci-collection-grid]:not([data-ci-ordering])').forEach(initialize);
  scan();
  // Dawn replaces ProductGridContainer after a filter/sort; initialize each new grid once.
  let scanPending=false;
  new MutationObserver(()=>{if(scanPending)return;scanPending=true;setTimeout(()=>{scanPending=false;scan();},0);}).observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true});
})();
